import React from 'react';
import { Outlet, useLocation } from 'react-router';
import Header from './Header';
import Footer from './Footer';
import FloatingActionBar from './FloatingActionBar';
import WhatsAppChatButton from './leads/WhatsAppChatButton';
import LanguageSuggestion from './LanguageSuggestion';

export default function Layout() {
  const location = useLocation();
  
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)' }}>
      <Header />
      
      {/* Main Content Area */}
      <main className="flex-grow pt-16 lg:pt-[72px]">
        <Outlet />
      </main>
      
      <Footer />
      <FloatingActionBar />
      <WhatsAppChatButton />
      <LanguageSuggestion />
    </div>
  );
}